module.exports = __webpack_public_path__ + "img/select-down-arrow.b705a927.svg";